/**
 * Dashboard - Create or update a classified advertisement
 */

'use strict';

var helper = require('../../misc/helpers');
var formImages = require('../formImages');

// Constructor
var FrontDashboardClassifiedsForm = function () {
    var bodyClasses = $('body').attr('class').split(" ");
    var i = 0;
    var found = false;
    while (i < bodyClasses.length && !found) {
        if (bodyClasses[i].indexOf('dashboard-classifieds-edit-') == 0) { // starts with
            found = true;
        }
        i++;
    }

    if (!found) {
        if (!$('body').hasClass('dashboard-classifieds-create')) {
            return;
        }
    }

    $(document).ready((function () {
        // Create or update?
        var id = parseInt($('#idPostEdited').val());
        if (id > 0) {
            this.isUpdate = true;
        }

        this.initFormFields();
        this.selectCategory();
        this.conditionalFields();
        this.checkMaxFileNumber();
        this.submitForm();
        formImages.addImages(this.maxImages, this.isUpdate);

        if (this.isUpdate) {
            this.initEdit();
            formImages.manageImages();
        }
    }).bind(this));
};

FrontDashboardClassifiedsForm.prototype = {
    lockAjaxForm: false,
    isUpdate: false,
    maxImages: 6,
    maxAttachment: 1,
    maxLogo: 1,
    courseDateStart: null,
    courseDateEnd: null,

    initEdit: function() {
        var self = this;

        setTimeout(function() {
            // Wait for AJAX requests and other stuff...
            $('.section-actions').css('opacity', 1);
            $('#edit-wait').hide();
            $('#classified-form').fadeIn();
            self.updateContainerHeight();
        }, 2000);

        $('#category').trigger('change');
    },

    initFormFields: function() {
        // Materialize dropdown
        $('#classified-form select').formSelect();

        // International Telephone Input
        // translated in french with the help of @link https://github.com/harold-s/harold-s/tree/master/intl-tel-input-french-translation

        var countryData = $.fn.intlTelInput.getCountryData();

        $.each(countryData, function(i, country) {
            country.name = helper.hashCountryDataTranslation[country.iso2];
        });

        $('.input-field .phone').each(function() {
            $(this).intlTelInput({
                autoPlaceholder: 'polite',
                utilsScript: comedien.assets + 'vendor/intl-tel-input/build/js/utils.js',
                initialCountry: 'ch',
                preferredCountries: ['ch', 'fr', 'be', 'de', 'it']
            });
        });

        // Date picker

        var monthsFull = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
        var weekdaysFull = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
        var weekdaysShort = ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'];
        var weekdaysLetter = ['D', 'L', 'M', 'M', 'J', 'V', 'S'];

        var configStartPicker = {
            container: '#site-header',
            format: 'dd.mm.yyyy',
            minDate: new Date(),
            defaultDate: new Date(),
            firstDay: 1,
            showClearBtn: true,
            i18n: {
                cancel: null,
                clear: comedien.i18n.pickadateClear,
                done: comedien.i18n.pickadateClose,
                weekdaysShort: weekdaysShort,
                weekdaysLetter: weekdaysLetter,
                weekdays:weekdaysFull,
                months: monthsFull
            },
            onClose: function () {

                if (typeof this.date === 'undefined')
                    return;

                var value = this.date;
                var day = value.getDate();
                var monthIndex = value.getMonth()+1;
                var year = value.getFullYear();

                if (monthIndex < 10) {
                    monthIndex = '0'+monthIndex;
                }

                if (day < 10) {
                    day = '0'+day;
                }

                if (value !== '') {
                    var datetime = year + '-' + monthIndex + '-' + day;
                    if (datetime.length >= 9) {
                        $('.row-form #course-start').val(datetime);
                        $('.row-form #course-start-date').removeClass('force-invalid').addClass('force-valid');
                    } else {
                        $('.row-form #course-start').val('');
                        $('.row-form #course-start-date').removeClass('force-valid').addClass('force-invalid');
                    }
                    $('.input-field label[for="course-start-date"]').addClass('active');
                } else {
                    $('.row-form #course-start').val('');
                    $('.row-form #course-start-date').removeClass('force-valid').addClass('force-invalid');
                    $('.input-field label[for="course-start-date"]').removeClass('active');
                }
            }
        };

        var configEndPicker = {
            container: '#site-header',
            format: 'dd.mm.yyyy',
            minDate: new Date(),
            defaultDate: new Date(),
            firstDay: 1,
            showClearBtn: true,
            i18n: {
                cancel: null,
                clear: comedien.i18n.pickadateClear,
                done: comedien.i18n.pickadateClose,
                weekdaysShort: weekdaysShort,
                weekdaysLetter: weekdaysLetter,
                weekdays:weekdaysFull,
                months: monthsFull
            },
            onClose: function () {

                if (typeof this.date === 'undefined')
                    return;

                var value = this.date;
                var day = value.getDate();
                var monthIndex = value.getMonth()+1;
                var year = value.getFullYear();

                if (monthIndex < 10) {
                    monthIndex = '0'+monthIndex;
                }

                if (day < 10) {
                    day = '0'+day;
                }

                if (value !== '') {
                    var datetime = year + '-' + monthIndex + '-' + day;
                    if (datetime.length >= 9) {
                        $('.row-form #course-end').val(datetime);
                        $('.row-form #course-end-date').removeClass('force-invalid').addClass('force-valid');
                    } else {
                        $('.row-form #course-end').val('');
                        $('.row-form #course-end-date').removeClass('force-valid').addClass('force-invalid');
                    }
                    $('.input-field label[for="course-end-date"]').addClass('active');
                } else {
                    $('.row-form #course-end').val('');
                    $('.row-form #course-end-date').removeClass('force-valid').addClass('force-invalid');
                    $('.input-field label[for="course-end-date"]').removeClass('active');
                }
            },
            onDraw: function() {

            }
        };

        this.courseDateStart = $('#course-start-date').datepicker(configStartPicker);
        this.courseDateEnd = $('#course-end-date').datepicker(configEndPicker);

        if (this.isUpdate) {
            var startSplit =  $('#course-start').val().split('-');
            var startDate = new Date(startSplit[0], startSplit[1]-1, startSplit[2]);
            var startDateString = startSplit[2]+'.'+startSplit[1]+'.'+startSplit[0];
            $('#course-start-date').val(startDateString)
            $('#course-start-date').datepicker('setDate', startDate);
            var endSplit =  $('#course-end').val().split('-');
            var endDate = new Date(endSplit[0], endSplit[1]-1, endSplit[2]);
            var endDateString = endSplit[2]+'.'+endSplit[1]+'.'+endSplit[0];
            $('#course-end-date').val(endDateString)
            $('#course-end-date').datepicker('setDate', endDate);
        }

        // TinyMCE
        tinymce.init({
            selector: '.tinymce',
            language: 'fr_FR',
            plugins: 'lists advlist paste link',
            toolbar: 'undo redo | bold italic | bullist numlist | link unlink | removeformat paste',
            menubar: false,
            branding: false,
            paste_data_images: false,
            paste_as_text: true,
            link_title: false,
            setup: function (editor) {
                editor.on('init', function (e) {
                    // Update height of columns
                    $('main#content > .col').matchHeight();
                });
            }
        });
    },

    selectCategory: function() {
        var self = this;

        $('#category').change(function() {
            var slug = $(this).find(':selected').data('slug');

            switch (slug) {
                case 'castings':
                case 'audition-theatrale':
                case 'shooting-pub':
                    $('.fields-castings').show();
                    $('.fields-price').hide();
                    $('.fields-petites-annonces').hide();
                    $('section#stage').hide();
                    $('section#section-logo').show();
                    break;
                case 'petites-annonces':
                case 'blog':
                    $('.fields-castings').hide();
                    $('.fields-price').show();
                    $('.fields-petites-annonces').show();
                    $('section#stage').hide();
                    $('section#section-logo').hide();
                    break;
                case 'stages':
                    $('.fields-castings').hide();
                    $('.fields-price').show();
                    $('.fields-petites-annonces').show(); // same as petites annonces
                    $('section#stage').fadeIn(500);
                    $('section#section-logo').show();
                    $('.event_place').html('stage');
                    break;
                case 'forum':
                    $('.fields-castings').hide();
                    $('.fields-price').show();
                    $('.fields-petites-annonces').show(); // same as petites annonces
                    $('section#stage').fadeIn(500);
                    $('section#section-logo').show();
                    $('.event_place').html('forum');
                    break;
                case 'figuration':
                    window.location.href = $(this).find(':selected').data('url');
                    break;
                default:
                    $('section.hide-on-load').hide();
                    break;
            }

            $('section.hide-on-load:not(#stage,#course-payment,#section-logo)').fadeIn(500, function() {
                self.updateContainerHeight();
            });

            if (slug != '') {
                $('.section-actions .fake-submit').removeClass('disabled');
            }

            var price = parseInt($('.input-field #price').val());

            if ((slug == 'stages' || slug == 'forum') && price > 0) {
                $('section#course-payment').fadeIn(500);
            } else {
                $('section#course-payment').hide();
            }
            self.updateContainerHeight();

        });
    },

    conditionalFields: function() {
        var self = this;

        // Payment for course or forum
        $('.input-field #price').on('input', function() {
            var price = parseInt($(this).val());
            var category = $('#category').find(':selected').data('slug');
            if ((category == 'stages' || category == 'forum') && price > 0) {
                $('section#course-payment').fadeIn(500);
            } else {
                $('section#course-payment').hide();
            }

            self.updateContainerHeight();
        });

        // Canton

        var $selectCanton = $('#course-address-canton');

        $('#course-address-country').change(function () {
            var country = $(this).val();
            if (country == 'ch') {
                $selectCanton.removeAttr('disabled');
            } else {
                $selectCanton.attr('disabled', 'disabled');
            }
            $selectCanton.formSelect('destroy');
            $selectCanton.formSelect();
        });
    },

    /**
     * Submit the form to create or update the classified ad.
     */
    submitForm: function() {
        var self = this;
        var form = $('#classified-form');
        var btnSubmit = $('.section-actions .fake-submit');
        var spinner = $('.section-actions .preloader-wrapper');

        form.submit(function(e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxForm = true;

            btnSubmit.addClass('disabled');
            spinner.css('display', 'inline-block').css('opacity', 1);
            $('.invalid', form).removeClass('invalid');

            var ajaxAction = 'dashboard.classifieds.create';
            if (self.isUpdate) {
                ajaxAction = 'dashboard.classifieds.update'
            }

            // Get HTML content from TinyMCE
            var description = tinymce.get('description').getContent();

            var slugCategory = $('#category').find(':selected').data('slug');
            var price = parseInt($('.input-field #price').val());

            var phoneIntNumber = $('.input-field #phone').intlTelInput('getNumber');
            $('.input-field #phoneInternational').val(phoneIntNumber);

            var mobileIntNumber = $('.input-field #mobile').intlTelInput('getNumber');
            $('.input-field #mobileInternational').val(mobileIntNumber);

            var formdata = false;
            if (window.FormData){
                formdata = new FormData(form[0]);

                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);
                formdata.append('description', description);

                // Bug fix Safari 11 / Webkit
                // @link https://stackoverflow.com/questions/49614091/safari-11-1-ajax-xhr-form-submission-fails-when-inputtype-file-is-empty
                // @link https://trac.webkit.org/changeset/230963/webkit
                $("input[type=file]", form).each(function () {
                    if ($(this).val() === "") {
                        formdata.delete($(this).attr("name"));
                    }
                });
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: formdata ? formdata : form.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security + "&description=" + description,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function(response) {
                if (response.success) {
                    var redirectDelay = 5000;

                    if (self.isUpdate) {
                        M.toast({html:'<span>'+ comedien.i18n.classifiedSuccessfullyUpdated +'</span>'}, redirectDelay);
                    } else {
                        redirectDelay = 10000;

                        switch (slugCategory) {
                            case 'castings':
                                $('#modal-dashboard-classified-created .forum').hide();
                                $('#modal-dashboard-classified-created .blog').hide();
                                $('#modal-dashboard-classified-created .castings').show();
                                $('#modal-dashboard-classified-created .petites-annonces').hide();
                                $('#modal-dashboard-classified-created .stages').hide();
                                $('#modal-dashboard-classified-created .shooting-pub').hide();
                                $('#modal-dashboard-classified-created .audition-theatrale').hide();
                                break;
                            case 'shooting-pub':
                                $('#modal-dashboard-classified-created .forum').hide();
                                $('#modal-dashboard-classified-created .blog').hide();
                                $('#modal-dashboard-classified-created .castings').hide();
                                $('#modal-dashboard-classified-created .petites-annonces').hide();
                                $('#modal-dashboard-classified-created .stages').hide();
                                $('#modal-dashboard-classified-created .shooting-pub').show();
                                $('#modal-dashboard-classified-created .audition-theatrale').hide();
                                break;
                            case 'audition-theatrale':
                                $('#modal-dashboard-classified-created .forum').hide();
                                $('#modal-dashboard-classified-created .blog').hide();
                                $('#modal-dashboard-classified-created .castings').hide();
                                $('#modal-dashboard-classified-created .petites-annonces').hide();
                                $('#modal-dashboard-classified-created .stages').hide();
                                $('#modal-dashboard-classified-created .shooting-pub').hide();
                                $('#modal-dashboard-classified-created .audition-theatrale').show();
                                break;
                            case 'petites-annonces':
                                $('#modal-dashboard-classified-created .petites-annonces .date').text('');
                                $('#modal-dashboard-classified-created .forum').hide();
                                $('#modal-dashboard-classified-created .blog').hide();
                                $('#modal-dashboard-classified-created .petites-annonces .date').text('');
                                $('#modal-dashboard-classified-created .petites-annonces').show();
                                $('#modal-dashboard-classified-created .castings').hide();
                                $('#modal-dashboard-classified-created .stages').hide();
                                $('#modal-dashboard-classified-created .shooting-pub').hide();
                                $('#modal-dashboard-classified-created .audition-theatrale').hide();
                                break;
                            case 'blog':
                                $('#modal-dashboard-classified-created .blog .date').text('');
                                $('#modal-dashboard-classified-created .forum').hide();
                                $('#modal-dashboard-classified-created .blog').show();
                                $('#modal-dashboard-classified-created .petites-annonces').hide();
                                $('#modal-dashboard-classified-created .castings').hide();
                                $('#modal-dashboard-classified-created .stages').hide();
                                $('#modal-dashboard-classified-created .shooting-pub').hide();
                                $('#modal-dashboard-classified-created .audition-theatrale').hide();
                                break;
                            case 'stages':
                                $('#modal-dashboard-classified-created .stages').show();
                                $('#modal-dashboard-classified-created .forum').hide();
                                $('#modal-dashboard-classified-created .blog').hide();
                                $('#modal-dashboard-classified-created .petites-annonces').hide();
                                $('#modal-dashboard-classified-created .castings').hide();
                                $('#modal-dashboard-classified-created .shooting-pub').hide();
                                $('#modal-dashboard-classified-created .audition-theatrale').hide();

                                if (price > 0) {
                                    $('#modal-dashboard-classified-created .stages .paid').show();
                                    $('#modal-dashboard-classified-created .stages .free').hide();
                                } else {
                                    $('#modal-dashboard-classified-created .stages .free').show();
                                    $('#modal-dashboard-classified-created .stages .paid').hide();
                                }
                                break;
                            case 'forum':
                                $('#modal-dashboard-classified-created .forum').show();
                                $('#modal-dashboard-classified-created .blog').hide();
                                $('#modal-dashboard-classified-created .stages').hide();
                                $('#modal-dashboard-classified-created .petites-annonces').hide();
                                $('#modal-dashboard-classified-created .castings').hide();
                                $('#modal-dashboard-classified-created .shooting-pub').hide();
                                $('#modal-dashboard-classified-created .audition-theatrale').hide();

                                if (price > 0) {
                                    $('#modal-dashboard-classified-created .forum .paid').show();
                                    $('#modal-dashboard-classified-created .forum .free').hide();
                                } else {
                                    $('#modal-dashboard-classified-created .forum .free').show();
                                    $('#modal-dashboard-classified-created .forum .paid').hide();
                                }
                                break;
                        }

                        $('#modal-dashboard-classified-created').modal('open');
                    }

                    setTimeout(function() {
                        var url = $('#redirectTo', form).val();
                        location.replace(url);
                    }, redirectDelay);
                } else {
                    var nbErrors = Object.keys(response.data.errors).length;
                    if (nbErrors > 0) {
                        $.each(response.data.errors, function (i, item) {
                            $('#' + i, form).addClass('invalid');
                            M.toast({html:'<span>'+ item +'</span>'}, 5000);
                        });
                    } else {
                       M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    }

                    btnSubmit.removeClass('disabled');
                }

                self.lockAjaxForm = false;
                spinner.css('opacity', 0).css('display', 'none');
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxForm = false;
                btnSubmit.removeClass('disabled');
                spinner.css('opacity', 0).css('display', 'none');
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });

        btnSubmit.on('click', function() {
            if (self.isUpdate) {
                // Prepare hidden input for images order

                var idImages = '';
                $('section#images .row-images .col-image').each(function(index, element) {
                    idImages += $(this).data('attachment-id') + ',';
                });
                idImages = idImages.replace(/,\s*$/, "");
                $('#classified-form #idImages').val(idImages);
            }

            var result = self.validateFormBeforeSubmit();

            if (result) {
                $('#classified-form').submit();
            }
        });

        $('#modal-dashboard-classified-created').modal({
            dismissible: false,
        });
    },

    /**
     * Validate the form before submit it.
     *
     * @returns {boolean}
     */
    validateFormBeforeSubmit: function() {
        // Number of documents
        var $fileUploadDoc = $('input#attachment');
        if (parseInt($fileUploadDoc.get(0).files.length) > this.maxAttachment) {
            M.toast({html:'<span>'+ comedien.i18n.maxUploadedDocument +'</span>'}, 5000);
            return false;
        }

        // Number of logo
        var $fileUploadLogo = $('input#logo');
        if (parseInt($fileUploadLogo.get(0).files.length) > this.maxLogo) {
            M.toast({html:'<span>'+ comedien.i18n.maxUploadedLogo +'</span>'}, 5000);
            return false;
        }

        return true;
    },

    checkMaxFileNumber: function() {
        var self = this;
        var $fileUploadDoc = $('input#attachment');
        var $fileUploadLogo = $('input#logo');

        // Number of documents
        $fileUploadDoc.on('change', function() {
            if (parseInt($fileUploadDoc.get(0).files.length) > self.maxAttachment) {
                M.toast({html:'<span>'+ comedien.i18n.maxUploadedDocument +'</span>'}, 5000);
                $fileUploadDoc.val('');
                return false;
            }
        });

        // Number of logo
        $fileUploadLogo.on('change', function() {
            if (parseInt($fileUploadLogo.get(0).files.length) > self.maxLogo) {
                M.toast({html:'<span>'+ comedien.i18n.maxUploadedLogo +'</span>'}, 5000);
                $fileUploadLogo.val('');
                return false;
            }
        });
    },

    /**
     * Update the content container/wrapper height.
     */
    updateContainerHeight: function() {
        $('main#content > .col').matchHeight();
        M.updateTextFields();
    },
};

module.exports = new FrontDashboardClassifiedsForm();
